import { graphql } from "react-relay";

export const DeleteGCPIntegrationMutation = graphql`
  mutation DeleteGCPIntegrationMutation($key: String!) {
    deleteGCPIntegration(input: { key: $key }) {
      problems {
        message
      }
    }
  }
`;
